import React, { useState } from 'react'

// redux
import { connect } from "react-redux";

// react router
import { useHistory } from "react-router-dom";

// bootstrap
import { Spinner } from "react-bootstrap";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// API
import { updateGuestEmail } from 'utlis/Apis/Cart_API';

// app messages
import { ERROR_WHILE__NAME, UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';

// toast
import { toast } from 'react-toastify';

function StepGuest(props) {
    // props
    const {
        setSectionLoading,

        setExistingEmail,

        commonToken,
        tempOrderId
    } = props

    // consts
    const history = useHistory();

    // states
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [isExistingUser, setIsExistingUser] = useState(false)

    // initial form values
    const initialFormValues = {
        email: '',
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        email: Yup.string().email().required('This field is required'),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // button and section loading
            setBtnDisabled(true);
            setBtnLoading(true);
            setSectionLoading(true);

            const requiredData = {
                temp_order_id: tempOrderId,
                email: values.email
            }

            // const required data
            updateGuestEmail(commonToken, requiredData).then(res => {
                // button and section loading
                setBtnDisabled(false);
                setBtnLoading(false);
                setSectionLoading(false);

                const resData = res.data

                // if request is success
                if (resData?.success) {
                    history.push({
                        pathname: "/checkout",
                        state: {
                            isGuest: true,
                            allowNavigation: true,
                            guestEmail: values.email,
                        }
                    })
                }

                // if request is error
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} updateGuestEmail`, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // button and section loading
                        setBtnDisabled(false);
                        setBtnLoading(false);
                        setSectionLoading(false);
                    },
                });
            })


            // setTimeout(() => {
            //     // enabling button loading and disabling button
            //     setBtnDisabled(true);
            //     setSectionLoading(true);


            //     history.push({
            //         pathname: "/checkout",
            //         state: {
            //             isGuest: true,
            //             allowNavigation: true,
            //             guestEmail: values.email,
            //         }
            //     })
            // }, 1000);


        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // checkout press
    // const checkUserEmail = debounce((ev) => {
    //     const emailVal = ev.target.value
    //     if (emailVal) {
    //         const isValid = ev.target.checkValidity()

    //         if (isValid) { // if email format is valid
    //             // enabling laoding
    //             setBtnLoading(true)
    //             setBtnDisabled(true)

    //             // email checking api
    //             checkEmailExistence(emailVal).then(res => {
    //                 const resData = res.data
    //                 // if email does not exists
    //                 if (resData.success) {
    //                     // disabling laoding
    //                     setBtnLoading(false)
    //                     setBtnDisabled(false)

    //                     setIsExistingUser(false) // IF THIS IS NOT AN EXISTING USER
    //                 }

    //                 // if email exists
    //                 if (resData.error) {
    //                     // disabling laoding
    //                     setBtnLoading(false)

    //                     setIsExistingUser(true) // IF THIS IS EXISTING USER

    //                     // dismissing all the previous toasts first
    //                     toast.dismiss();

    //                     // showing the error message
    //                     toast.info("The email is already registered with us. please login", {
    //                         autoClose: 2000,
    //                         onClose: () => {
    //                             // disabling laoding
    //                             setBtnDisabled(false)

    //                             // setting current email to the login
    //                             setExistingEmail(emailVal)
    //                         }
    //                     });
    //                 }

    //             }).catch(err => {
    //                 console.log("Error in the checkEmailExistence Api ", err.message);
    //             })
    //         }
    //     } else {
    //         // disabling the button
    //         setBtnDisabled(true)
    //     }
    // }, 200)


    return (
        <React.Fragment>
            <div className="frac">
                <div className="header-sec">
                    <p className="head st-fs-19 st-fw-800 mb-2">Guest Checkout</p>
                    <p className="desc mb-3">If desired, you may create an account at the end of the checkout process.</p>
                </div>

                <div className="content-sec">
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        {/* input field */}
                        <div className={`form-item mb-3 ${(formik.touched.email && formik.errors.email) ? "has-error" : ""}`}>
                            <label className="mb-2 st-fw-800">Email <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                            <input
                                type="email"
                                className="form-control rounded-0"
                                {...formik.getFieldProps('email')}
                            // onFocus={ev => {
                            //     setBtnDisabled(true)
                            // }}
                            // onBlur={ev => {
                            //     formik.handleBlur(ev)
                            //     checkUserEmail(ev)
                            // }}
                            />
                            {
                                (formik.touched.email && formik.errors.email) ? (
                                    <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                        {formik.errors.email}
                                    </div>
                                ) : null
                            }
                        </div>

                        <div className="btns pt-1">
                            <button
                                type="submit"
                                className="btn rounded-0 btn-block text-uppercase st-fw-800 default-btn"
                                disabled={isExistingUser || btnDisabled}>
                                {
                                    btnLoading ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        <span>guest Checkout</span>
                                    )
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        tempOrderId: state.auth.tempOrderId,
        commonToken: state.auth.commonToken,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//     };
// };

export default connect(getDataFromStore, null)(StepGuest);